import React from 'react'
import Link from 'next/link'

import {t} from '@lib/helpers'

const Hero = () => {
  return (
    <section className='Landing__hero'>
      <div className='Landing__hero__content'>
        <h1 className='Landing__hero__h1'>
          {t('pages.index.landing.hero.h1')}
        </h1>
        <p className='Landing__hero__p'>{t('pages.index.landing.hero.p')}</p>
        <div className='Landing__hero__buttons'>
          <Link href='/services'>
            <a className='Landing__btn Landing__btn--primary'>
              {t('pages.index.landing.hero.btn_primary')}
            </a>
          </Link>
          <Link href='/contact'>
            <a className='Landing__btn Landing__btn--outline'>
              {t('pages.index.landing.hero.btn_outline')}
            </a>
          </Link>
        </div>
      </div>
      <div className='Landing__hero__image-wrapper'>
        <div className='Landing__hero__image'>
          <img
            src='/images/Landing_1.png'
            alt='Enterprise Data Transformation'
          />
        </div>
        <div className='Landing__hero__green-bar' />
      </div>
    </section>
  )
}

export default Hero
